export class ExportCSV {
  public "Sl.No": number;
  public "Employees": string;
  public "Employee Id": number;
  public "Time Spent(In Hrs)": number;
  constructor(d: any = {}, idx) {
    this["Sl.No"] = idx + 1 || 0;
    this["Employees"] = d.empdetails.Empname || "";
    this["Employee Id"] = d.empdetails.Empno || 0;
    this["Time Spent(In Hrs)"] = d.spentHrs || 0;
    if (d.empdetails.businessUnit === "biologics") {
      this["Program Name"] = d.empdetails.Project.programName
        ? d.empdetails.programName
        : "";
      this["Project Manager Name"] = d.empdetails.projectManager
        ? d.empdetails.projectManager
        : "";
    }
  }
}
export class ExportMultiCSV {
  public "Sl.No": number;
  public "Project Name": string;
  public "Planned Hours": any;
  public "No of Employees": number;
  public "Start Date": string;
  public "End Date": string;
  public "Total hrs": any;
  constructor(d: any = {}, idx) {
    this["Sl.No"] = idx + 1 || 0;
    this["Project Name"] = d.Project.Project || "";

    this["Planned Hours"] = d.Project.plannedHour || "";
    this["No of Employees"] = d.empDetails.length || 0;

    this["Start Date"] = d.Project.startDate
      ? d.Project.startDate.split("T")[0].split("-").reverse().join("-")
      : "";
    this["End Date"] = d.Project.endDate
      ? d.Project.endDate.split("T")[0].split("-").reverse().join("-")
      : "";
    // this['Start Date'] = d.Project.startDate ? new Date(d.Project.startDate).getDay() + '/' + (new Date(d.Project.startDate).getMonth() + 1) + '/' + new Date(d.Project.startDate).getFullYear() : '';
    // this['End Date'] = d.Project.endDate ? new Date(d.Project.endDate).getDay() + '/' + (new Date(d.Project.endDate).getMonth() + 1) + '/' + new Date(d.Project.endDate).getFullYear() : '';
    if (
      d.Project.businessUnit === "ipdo" ||
      d.Project.businessUnit === "biologics" ||
      d.Project.businessUnit === "chinateam" ||
      d.Project.businessUnit == "aps"
    ) {
      this["Total Spent hrs"] = d.totalTimePerproject
        ? d.totalTimePerproject
        : "-";
    }
    if (d.Project.businessUnit === "biologics") {
      this["Program Name"] = d.Project.programName ? d.Project.programName : "";
      this["Project Manager Name"] = d.Project.projectManager
        ? d.Project.projectManager
        : "";
    }
  }
}

export class UpdateProject {
  public projectID: string;
  public updateItems: UpdateItems;
  public userObj: any;
  constructor(oldData: any = {}, newData: any = {}, userObj: any = {}) {
    this.projectID = oldData.projectID;
    this.updateItems = new UpdateItems(newData) || new UpdateItems({});
    this.userObj = userObj || "";
  }
}

export class UpdateItems {
  public Project: string;
  public startDate: string;
  public endDate: string;
  constructor(data: any = {}) {
    this.Project = data.Project;
    this.startDate = data.originalstartDateobj.formatted;
    this.endDate = data.originalendDateobj.formatted;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/project/project.ts